import { Fragments } from "requests";
import { FormValues } from "./types";

export const getDefaultValues = (
  dentalChart: NonNullable<Fragments.StoredDentalChartings>[number] | null
): FormValues | null => {
  if (!dentalChart) {
    return null;
  }

  return {
    oralSurgeries: dentalChart.oralSurgeries || [],
    sutureMaterial: dentalChart.sutureMaterial || null,
    restorations: dentalChart.restorations || [],
    restoratives: dentalChart.restoratives || null,
    crCementation: dentalChart.crCementation || null,
    endodontics: dentalChart.endodontics || [],
    obturation: dentalChart.obturation || null,
    distalWorkingLength: dentalChart.distalWorkingLength || null,
    mesialWorkingLength: dentalChart.mesialWorkingLength || null,
    palatalWorkingLength: dentalChart.palatalWorkingLength || null,
    distalMarFile: dentalChart.distalMarFile || null,
    mesialMarFile: dentalChart.mesialMarFile || null,
    palatalMarFile: dentalChart.palatalMarFile || null,
    technique: dentalChart.technique || "",
    treatmentComment: dentalChart.treatmentComment || ""
  };
};
